import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ACTION_NAVIGATE_SYNC,
  NavigateSyncResponse,
  syncPathname,
} from '@tiendanube/nexo';
import nexo from './nexoClient';

function NexoSyncRoute({ children }: { children: JSX.Element }) {
  const { pathname, search } = useLocation();
  const { push: goTo, replace: replaceTo } = useHistory();

  useEffect(() => {
    const path = search ? `${pathname}${search}` : pathname;
    syncPathname(nexo, path);
  }, [pathname, search]);

  useEffect(() => {
    const unsuscribe = nexo.suscribe(
      ACTION_NAVIGATE_SYNC,
      ({ path, replace }: NavigateSyncResponse) => {
        const currentPathname = window.location.pathname;
        const currentSearch = window.location.search;
        const pathWithSearch = currentSearch
          ? `${currentPathname}${currentSearch}`
          : currentPathname;
        if (pathWithSearch !== path) {
          replace ? replaceTo(path) : goTo(path);
        }
      },
    );

    return unsuscribe;
  }, [goTo, replaceTo]);

  return children;
}
export default NexoSyncRoute;
